module.exports = __webpack_public_path__ + "static/media/June_CLD_1129.8fb971d7.pdf";